import { ADD_Z_REPORT, APPEND_Z_REPORTS, APPEND_Z_REPORT_FOR_TODAY, SET_Z_REPORT, SET_Z_REPORT_DATE_FROM, SET_Z_REPORT_DATE_TO, SET_Z_REPORT_TEST_IS_LOADING, SET_Z_REPORTS, SET_Z_REPORTS_FOR_TODAY, SET_Z_REPORTS_TOTAL_LENGTH, SET_Z_REPORT_CASH_DATA, SET_Z_REPORT_DATEV, SET_Z_REPORT_SELECTED_ORDER, SET_Z_REPORT_SHOW_ORDERS_TABLE, SET_Z_REPORT_SHOW_ORDER, SET_Z_REPORT_SHOW_ORDER_DATA, SET_Z_REPORT_SHOW_PAYMENT_METHOD, SET_Z_REPORT_SHOW_ABORT_ORDER, SET_Z_REPORT_SAVING_PDF } from '../../actionTypes/zreport'

const initialState = {
	reports: [],
	reportsTotalLength: 0,
	report: null,
	dateFrom: null,
	dateTo: null,
	testIsLoading: false,
	reportsForToday: [],
	reportCashData: null,
	reportDateV: null,
	selectedOrder: null,
	savingPdf: false,
	orderModal: {
		showOrdersTable: false,
		showOrder: false,
		showOrderData: false,
		showPaymentMethod: false,
		showAbortOrder: false
	},
}

export function zReportReducer(state = initialState, action) {
	switch (action.type) {
		case SET_Z_REPORTS:
			return {
				...state,
				reports: action.value,
			}
		case SET_Z_REPORTS_TOTAL_LENGTH:
			return {
				...state,
				reportsTotalLength: action.value,
			}
		case SET_Z_REPORT:
			return {
				...state,
				report: action.value,
			}
		case APPEND_Z_REPORTS:
			return {
				...state,
				reports: state.reports.concat(...action.value),
			}
		case SET_Z_REPORT_DATE_FROM:
			return {
				...state,
				dateFrom: action.value,
			}
		case SET_Z_REPORT_DATE_TO:
			return {
				...state,
				dateTo: action.value,
			}
		case SET_Z_REPORT_TEST_IS_LOADING:
			return {
				...state,
				testIsLoading: action.value
			}
		case SET_Z_REPORTS_FOR_TODAY:
			return {
				...state,
				reportsForToday: action.value
			}
		case APPEND_Z_REPORT_FOR_TODAY:
			return {
				...state,
				reportsForToday: [action.value, ...state.reportsForToday]
			}
		case ADD_Z_REPORT:
			return {
				...state,
				reports: [action.value, ...state.reports]
			}
		case SET_Z_REPORT_CASH_DATA:
			return {
				...state,
				reportCashData: action.value,
			}
		case SET_Z_REPORT_DATEV:
			return {
				...state,
				reportDateV: action.value,
			}
		case SET_Z_REPORT_SELECTED_ORDER:
			return {
				...state,
				selectedOrder: action.value,
			}
		case SET_Z_REPORT_SHOW_ORDERS_TABLE:
			return {
				...state,
				orderModal: {
					...state.orderModal,
					showOrdersTable: action.value,
				}
			}
		case SET_Z_REPORT_SHOW_ORDER:
			return {
				...state,
				orderModal: {
					...state.orderModal,
					showOrder: action.value,
				},
			}
		case SET_Z_REPORT_SHOW_ORDER_DATA:
			return {
				...state,
				orderModal: {
					...state.orderModal,
					showOrderData: action.value,
				},
			}
		case SET_Z_REPORT_SHOW_PAYMENT_METHOD:
			return {
				...state,
				orderModal: {
					...state.orderModal,
					showPaymentMethod: action.value,
				},
			}
		case SET_Z_REPORT_SHOW_ABORT_ORDER:
			return {
				...state,
				orderModal: {
					...state.orderModal,
					showAbortOrder: action.value
				}
			}
		case SET_Z_REPORT_SAVING_PDF:
			return {
				...state,
				savingPdf: action.value,
			}
		default:
			return state
	}
}


